import {useMecleeApi} from "#imports";

export const createCheckoutUseCase = async (psychologist: string, timeZone: string, serviceId?: string) => {
  const {put} = useMecleeApi();

  return await put(`/marketplace/checkout`, {
    psychologist,
    timeZone,
    serviceId,
  }, false);
}

export const getCheckoutUseCase = async (id: string) => {
  const {get} = useMecleeApi();

  return await get(`/marketplace/checkout/${id}`, {});
}

export const setServiceUseCase = async (checkoutId: string, serviceId: string) => {
  const {post} = useMecleeApi();

  return await post(`/marketplace/checkout/${checkoutId}/attributes/service`, {
    serviceId,
  }, false);
}

export const setTimeZoneUseCase = async (checkoutId: string, timeZone: string) => {
  const {post} = useMecleeApi();

  return await post(`/marketplace/checkout/${checkoutId}/attributes/timeZone`, {
    timeZone,
  }, false);
}

export const setRequestsUseCase = async (checkoutId: string, requests: string[]) => {
  const {post} = useMecleeApi();

  return await post(`/marketplace/checkout/${checkoutId}/attributes/requests`, {
    requests,
  }, false);
}

export const setCommentUseCase = async (checkoutId: string, comment: string) => {
  const {post} = useMecleeApi();

  return await post(`/marketplace/checkout/${checkoutId}/attributes/comment`, {
    comment,
  }, false);
}

export const setShareRequestsUseCase = async (checkoutId: string, shareRequests: boolean) => {
  const {post} = useMecleeApi();

  return await post(`/marketplace/checkout/${checkoutId}/attributes/shareRequests`, {
    share: shareRequests,
  }, false);
}

export const fetchScheduleUseCase = async (checkoutId: string) => {
  const {get} = useMecleeApi();

  return await get(`/marketplace/checkout/${checkoutId}/schedule`, {});
}

export const addItemUseCase = async (checkoutId: string, timeSlot: string) => {
  const {put} = useMecleeApi();

  return await put(`/marketplace/checkout/${checkoutId}/items`, {
    timeSlot,
  }, false);
}

export const removeItemUseCase = async (checkoutId: string, itemId: string) => {
  const {del} = useMecleeApi();

  return await del(`/marketplace/checkout/${checkoutId}/items/${itemId}`, false);
}

export const applyPromoCodeUseCase = async (checkoutId: string, promoCode: string) => {
  const {post} = useMecleeApi();

  return await post(`/marketplace/checkout/${checkoutId}/promoCode`, {
    code: promoCode,
  }, false);
}

export const checkoutUseCase = async (checkoutId: string, requests: string[] = [], matchingId: string|undefined) => {
  const {post} = useMecleeApi();

  return await post(`/marketplace/checkout/${checkoutId}/checkout`, {
    requests,
    matchingId,
  }, false);
}

export const pollUseCase = async (checkoutId: string) => {
  const {post} = useMecleeApi();

  return await post(`/marketplace/checkout/${checkoutId}/poll`, {}, false);
}
